import { useEffect, useState } from "react";
import axios from "axios";

export default function useCommitStats(projectId) {
  const [commitStats, setCommitStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (!projectId) return;

    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await axios.get(
          `${BACKEND_URL}/projects/${projectId}/commits/stats/`
        );

        if (!cancelled) setCommitStats(res.data);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [projectId, BACKEND_URL]);

  return { commitStats, loading, error };
}
